import React, { useState } from "react";
import { apiService } from "../services/api/netlifyService";

export const Newsletter: React.FC = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error" | "api-error">("idle");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email || !emailRegex.test(email)) {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 5000);
      return;
    }
    
    setLoading(true);
    
    try {
      // In development, skip API call if function not available
      if (process.env.NODE_ENV === 'development') {
        console.log('Development mode: Would store email:', email);
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 1000));
      } else {
        await apiService.addWaitlistEmail(email);
      }
      
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 5000);
    } catch (err) {
      console.error("Error submitting newsletter email:", err);
      setStatus("api-error");
      setTimeout(() => setStatus("idle"), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="newsletter" className="newsletter-section">
      <div className="newsletter-background">
        <img 
          src="img/newsletter.webp" 
          alt="Newsletter Endocomunidad" 
          className="newsletter-image"
        />
      </div>
      <div className="newsletter-overlay"></div>
      <div className="newsletter-content">
        <h2 className="newsletter-title">
          SUSCRÍBETE AL NEWSLETTER
        </h2>
        <p className="newsletter-subtitle">
          Y FORMA PARTE DE ESTA COMUNIDAD.
        </p>
        
        <form onSubmit={handleSubmit} className="newsletter-form" noValidate>
          <div className="newsletter-input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu correo electrónico"
              className={`newsletter-input ${status === "error" ? "newsletter-input-error" : ""}`}
              required
              disabled={loading}
            />
            
            {status === "success" && (
              <div className="newsletter-message newsletter-success">
                ¡Gracias por suscribirte y formar parte de nuestra comunidad!
              </div>
            )}
            {status === "error" && (
              <div className="newsletter-message newsletter-error">
                Por favor, ingresa un correo válido.
              </div>
            )}
            {status === "api-error" && (
              <div className="newsletter-message newsletter-error">
                Hubo un error al procesar tu solicitud. Por favor, intenta nuevamente.
              </div>
            )}
            
            <button type="submit" className="newsletter-button" disabled={loading}>
              {loading ? "ENVIANDO..." : "SUSCRIBIRSE"}
            </button>
          </div>
        </form>

        <p className="newsletter-privacy">
          Al suscribirte, aceptas recibir información y noticias de Endocomunidad.
        </p>
      </div>
    </div>
  );
};

